var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlertBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15165_5369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.3332C11.4477 17.3332 11 16.8854 11 16.3332L11.0001 11.6665C11.0001 11.1142 11.4478 10.6665 12.0001 10.6665C12.5524 10.6665 13.0001 11.1142 13.0001 11.6665L13 16.3332C13 16.8855 12.5523 17.3332 12 17.3332Z",
    fill: "#002CFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 7.99984C10.6667 7.26346 11.2636 6.6665 12 6.6665C12.7364 6.6665 13.3333 7.26346 13.3333 7.99984C13.3333 8.73622 12.7364 9.33317 12 9.33317C11.2636 9.33317 10.6667 8.73622 10.6667 7.99984Z",
    fill: "#002CFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3333 11.9998C21.3333 17.1545 17.1546 21.3332 12 21.3332C6.84533 21.3332 2.66666 17.1545 2.66666 11.9998C2.66666 6.84518 6.84533 2.6665 12 2.6665C17.1546 2.6665 21.3333 6.84518 21.3333 11.9998ZM19.3333 11.9998C19.3333 16.0499 16.0501 19.3332 12 19.3332C7.9499 19.3332 4.66666 16.0499 4.66666 11.9998C4.66666 7.94975 7.9499 4.6665 12 4.6665C16.0501 4.6665 19.3333 7.94975 19.3333 11.9998Z",
    fill: "#002CFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15165_5369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertBlue);
export default __webpack_public_path__ + "static/media/iconAlertBlue.fea09a538c10fff7043204902c029a4e.svg";
export { ForwardRef as ReactComponent };